export default __webpack_public_path__ + "static/media/174.07f7440d.png";